import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'ship_customer': {
    title: '开票客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '开票客户编号'
    }
  },
  'ship_cust_name': {
    title: '开票客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'order_customer': {
    title: '订单客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户编码'
    }
  },
  'order_cust_name': {
    title: '订单客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'order_customer_type': {
    describe: true,
    title: '订单客户类型',
    type: 'select',
    equation: all,
    dictionary: 'A0009'
  },
  'new_order_customer': {
    title: '最新客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '最新客户编码'
    }
  },
  'zzfld000001': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'zzfld000002': {
    describe: true,
    title: '省份',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'zzfld000003': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'zzfld00001h': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元(订单客户)', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale', // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
    width: 200
  },
  'zzfld00003e': {
    describe: true,
    title: '基地（订单客户）',
    type: 'select',
    equation: all,
    dictionary: 'base',
    width: 180
  },
  'new_order_cust_name': {
    title: '最新客户名称',
    type: 'input',
    equation: cusname
  },
  'ycate': {
    describe: true,
    title: '品牌(月报分类)',
    type: 'select',
    equation: city,
    dictionary: 'A0016',
    width: 180
  },
  'use_zzfld9': {
    title: '件',
    xlsxFmt: {
      t: 'n'
    }
  },
  'use_dun': {
    title: '吨',
    xlsxFmt: {
      t: 'n'
    }
  },
  'net_value': {
    title: '折前金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'pure_value': {
    title: '折后金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/dealersMakeInvoiceStatisticalReportForms.js